<template>
  <div>
    <!-- 标题区 -->
    <el-card class="add-product-info-header"
             shadow="nerver">
      <!-- 新增套餐 -->
      <el-button size="mini"
                 type="primary"
                 @click="addTab(editableTabsValue)">新增套餐</el-button>
    </el-card>
    <!-- 套餐标签 与 内容栏 -->
    <el-tabs v-model="editableTabsValue"
             type="border-card"
             closable
             @tab-remove="removeTab"
             @tab-click="tabClick()">
      <el-tab-pane v-for="(item, index) in editableTabs"
                   :key="item.name"
                   :label="item.sku_name"
                   :name="item.name">
        <!-- 套餐名称 -->
        <keep-alive>
          <div class="package_title">
            <label>套餐名称：</label>
            <el-input style="width: 300px"
                      size="mini"
                      type="text"
                      @blur="putupLable"
                      placeholder="请输入套餐名称"
                      v-model="package_name"
                      maxlength="16"
                      show-word-limit></el-input>
          </div>
        </keep-alive>
        <!-- 套餐编号 -->
        <div class="package_code">
          <label>套餐编码：</label>
          <el-input style="width: 200px"
                    size="mini"
                    type="text"
                    @blur="putupNum"
                    placeholder="请输入套餐编号"
                    v-model="out_sku_id"
                    maxlength="16"
                    show-word-limit></el-input>
          <el-link style="margin-left: 10px"
                   @click="creatOutSkuId"
                   :underline="false"
                   type="primary"
                   icon="el-icon-refresh">生成编号</el-link>
        </div>
        <!-- 套餐说明 -->
        <div class="package_info">
          <label>套餐介绍：</label>
          <div>
            <el-input style="width: 200px"
                      size="mini"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      type="textarea"
                      @blur="putupIntro"
                      placeholder="请输入套餐介绍"
                      v-model="package_introduce"
                      maxlength="50"
                      show-word-limit></el-input>
          </div>
        </div>
        <el-divider></el-divider>
        <!-- 价格包含 -->
        <div class="package_info">
          <label>价格包含：</label>
          <div>
            <el-input style="width: 300px"
                      size="mini"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      type="textarea"
                      @blur="putPriceInclude"
                      placeholder="请输入"
                      v-model="price_include"
                      maxlength="50"
                      show-word-limit></el-input>
          </div>
        </div>

        <!-- 价格不含 -->
        <div class="package_info">
          <label>价格不含：</label>
          <div>
            <el-input style="width: 300px"
                      size="mini"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      type="textarea"
                      @blur="putPriceExclude"
                      placeholder="请输入"
                      v-model="price_exclude"
                      maxlength="50"
                      show-word-limit></el-input>
          </div>
        </div>

        <!-- 预定须知 -->
        <!-- <div class="package_info">
          <label>预定须知：</label>
          <div>
            <editor-info ref="editor"></editor-info>
            <p>套餐预定的注意事项，也是发送给预定人的订单通知</p>
          </div>
        </div>-->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'sku-setting',
  components: {},
  data() {
    return {
      input: '',
      selectDate: '',
      disabled: false,
      radio: '1',
      package_name: '',
      out_sku_id: '',
      package_introduce: '',
      price_include: '',
      price_exclude: '',
      priceAdult: '',
      priceChild: '',
      editableTabsValue: '',
      // this.editableTabsValue 当前选中的name属性值
      editableTabs: [
        // {
        //   sku_name: '新套餐',
        //   name: '1',
        //   content: '',
        // }
      ],
      tabIndex: '',
    }
  },
  created() {
    this.addTab()
  },
  methods: {
    // -------------------------------------------------------------------------------------------------
    creatOutSkuId() {},
    // 添加一个套餐 标签
    addTab(targetName) {
      // console.log(this.editableTabs.length);  && 与 且
      if (this.editableTabs.length >= 1 && this.package_name == '') {
        // 点击新增按钮时：检查当前input 是否为空，如果为空，弹出提示
        this.$alert('套餐标题不能为空', '警告')
      } else {
        // 否则执行新增操作
        let newTabName = ++this.tabIndex + '' //把序号name，int类型，变字符串类型
        this.editableTabs.push({
          //向列表里推空数据
          sku_name: '新套餐',
          name: newTabName,
        })
        this.editableTabsValue = newTabName //并切换至 切换标签
        this.emptyInput()
      }
    },
    // 让数据为空的一个函数
    emptyInput() {
      this.package_name = ''
      this.out_sku_id = ''
      this.package_introduce = ''
      this.price_include = ''
      this.price_exclude = ''
      this.pro_intro = ''
    },
    // 切换标签时
    tabClick() {
      // 获取当前的 number 提取对象，把对象的值扔到 套餐名称里
      for (let i of this.editableTabs) {
        if (i.name == this.editableTabsValue) {
          if (i.sku_name == '新套餐') {
            this.package_name = ''
            this.emptyInput()
          } else {
            this.package_name = i.sku_name
            this.out_sku_id = i.pro_num
            this.package_introduce = i.package_introduce
            this.price_include = i.price_include
            this.price_exclude = i.price_exclude
            // this.package_introduce = i.pro_intro;
            // this.priceAdult = i.price_adult;
            // this.priceChild = i.price_child;
          }
        }
      }
    },
    // -----------------------【监听blur失去焦点，检查是否为空。进行赋值操作】-----------------------
    // 填写完成一个套餐名称时时,如果为空，则弹出警告
    putupLable() {
      if (this.package_name == '') {
        this.$alert('套餐标题不能为空', '警告')
      } else {
        // console.log(this.editableTabs[0]);
        for (let i of this.editableTabs) {
          if (i.name == this.editableTabsValue) {
            i.sku_name = this.package_name
          }
        }
      }
    },
    // 完成编号的时候[blur失去焦点]
    putupNum() {
      for (let i of this.editableTabs) {
        if (i.name == this.editableTabsValue) {
          i['out_sku_id'] = this.out_sku_id // 向对象中添加属性
        }
      }
    },
    // 添加说明[blur失去焦点]
    putupIntro() {
      for (let i of this.editableTabs) {
        if (i.name == this.editableTabsValue) {
          i['package_introduce'] = this.package_introduce
        }
      }
    },
    // 添加价格包含[blur失去焦点]
    putPriceInclude() {
      for (let i of this.editableTabs) {
        if (i.name == this.editableTabsValue) {
          i['price_include'] = this.price_include
        }
      }
    },
    // 添加价格不含[blur失去焦点]
    putPriceExclude() {
      for (let i of this.editableTabs) {
        if (i.name == this.editableTabsValue) {
          i['price_exclude'] = this.price_exclude
        }
      }
    },
    //套餐预定须知
    putBookingRuls() {
      console.log('henhang ')
      for (let i of this.editableTabs) {
        if (i.name == this.editableTabsValue) {
          i['sku_booking_ruls'] = this.$refs.introduce
        }
      }
    },
    // putPriceChild() {
    //   for (let i of this.editableTabs) {
    //     if (i.name == this.editableTabsValue) {
    //       i["price_child"] = this.priceChild;
    //     }
    //   }
    // },
    // 删除一个套餐
    removeTab(targetName) {
      // 清空：1。删除空套餐，最后一个， 2.有空套餐，删除其他套餐。
      // 3删除最后一个有值套餐。4.最后一个有值，删除其他有值套餐
      // 是否是最后一套餐，最后一个空套餐，最后一个有值套餐

      let tabs = this.editableTabs
      let activeName = this.editableTabsValue
      if (tabs.length == 1) {
        this.$alert('无法删除最后一个套餐', '警告')
        return
      } else if (activeName === targetName) {
        // 如果 当前 标签  等于  点击的标签
        tabs.forEach((tab, index) => {
          // forEach：列出数组的每个元素
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
        // 看点击的是哪一个对象
      }
      // 删除后： 定位当前标签，或后一个标签，
      this.editableTabsValue = activeName
      // 补充,删除后显示的那个标签的数据：
      // 删除没有点击的那个标签对象
      this.editableTabs = tabs.filter((item) => item.name !== targetName)
    },
    //
  },
}
</script>

<style>
.sku_area {
  background-color: rgb(241, 241, 241);
  margin-top: 10px;
  padding: 10px 0;
  border-radius: 5px;
}
.package_stock {
  margin: 10px 10px;
}

.package_title {
  margin-left: 20px;
  margin-top: 20px;
}

.package_code {
  margin-left: 20px;
  margin-top: 30px;
}
.package_price {
  margin-left: 20px;
  margin-top: 10px;
}

.package_info {
  display: flex;
  margin-left: 20px;
  margin-top: 30px;
  /* margin-bottom: 50px; */
}

.package_attribute {
  display: flex;
  margin-top: 10px;
  margin-bottom: 50px;
}

.setting-pkg {
  display: flex;
}

.add-product-info-header {
  border-radius: 3px 3px 0px 0px;
}

.add-package-title-middle {
  border-radius: 0px 0px 0px 0px;
}

.add-product-info-content {
  border-radius: 0px 0px 3px 3px;
}

.el-tabs--border-card {
  box-shadow: none;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
}
</style>